<script setup>
// ContactsBulkActionsBar.vue — barra contextual que aparece quando ha
// >=1 contato selecionado. Sticky no topo da lista (z acima do header
// de colunas) com o numero de selecionados e acoes em batch
// (exportar selecionados, excluir, limpar). Acoes que ainda nao tem
// suporte de backend ficam stub com emit, parent decide o que faz.
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  count: { type: Number, required: true },
});

const emit = defineEmits(['export', 'delete', 'clear']);

const { t } = useI18n();
</script>

<template>
  <div
    v-show="props.count > 0"
    class="sticky top-0 z-10 flex items-center justify-between gap-3 px-4 h-11 border-b border-n-weak bg-n-blue-3"
  >
    <div class="flex items-center gap-3 min-w-0">
      <span class="text-sm font-medium text-n-blue-12">
        {{
          t('CONTACTS_LAYOUT.BULK_ACTIONS.SELECTED_COUNT', {
            count: props.count,
          })
        }}
      </span>
      <button
        type="button"
        class="text-xs text-n-blue-11 hover:text-n-blue-12 underline-offset-2 hover:underline"
        @click="emit('clear')"
      >
        {{ t('CONTACTS_LAYOUT.BULK_ACTIONS.CLEAR') }}
      </button>
    </div>
    <div class="flex items-center gap-2">
      <Button
        :label="t('CONTACTS_LAYOUT.BULK_ACTIONS.EXPORT')"
        icon="i-lucide-upload"
        color="slate"
        variant="ghost"
        size="xs"
        @click="emit('export')"
      />
      <Button
        :label="t('CONTACTS_LAYOUT.BULK_ACTIONS.DELETE')"
        icon="i-lucide-trash-2"
        color="ruby"
        variant="ghost"
        size="xs"
        @click="emit('delete')"
      />
    </div>
  </div>
</template>
